import BWAccordion from 'components/shared/BWAccordion';
import FormDatePicker from 'components/shared/BWFormControl/FormDate';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormTextArea from 'components/shared/BWFormControl/FormTextArea';
import React from 'react';

const RecruitmentInformation = ({ disabled, title }) => {
  return (
    <BWAccordion title={title}>
      <div className='bw_row'>
        <div className='bw_col_6'>
          <FormItem label='Họ và tên' disabled={disabled} isRequired>
            <FormInput
              field='full_name'
              placeholder='Nhập họ và tên'
              validation={{
                required: 'Họ và tên là bắt buộc'
              }}
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem label='Email' disabled={disabled} isRequired>
            <FormInput
              field='email'
              placeholder='Nhập email'
              validation={{
                required: 'Email là bắt buộc',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Email không hợp lệ'
                }
              }}
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem label='Số điện thoại' disabled={disabled} isRequired>
            <FormInput
              field='phone_number'
              placeholder='Nhập số điện thoại'
              validation={{
                required: 'Số điện thoại là bắt buộc'
              }}
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem disabled={disabled} label='Ngày sinh' isRequired>
            <FormDatePicker
              style={{ width: '100%' }}
              type='text'
              field='dob'
              placeholder='dd/mm/yyyy'
              bordered={false}
              format={'DD/MM/YYYY'}
              validation={{
                required: 'Ngày sinh là bắt buộc'
              }}
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem disabled={disabled} label='Ngày ứng tuyển' isRequired>
            <FormDatePicker
              style={{ width: '100%' }}
              type='text'
              field='apply_date'
              placeholder='dd/mm/yyyy'
              bordered={false}
              format={'DD/MM/YYYY'}
              validation={{
                required: 'Ngày ứng tuyển là bắt buộc'
              }}
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem label='Địa chỉ' disabled={disabled}>
            <FormInput
              field='address'
              placeholder='Nhập địa chỉ'
            />
          </FormItem>
        </div>
        <div className='bw_col_12'>
          <FormItem label='Ứng viên tự giới thiệu' disabled={disabled}>
            <FormTextArea
              field='introduce'
              placeholder='Ứng viên chưa nhập gì'
              rows={4}
            />
          </FormItem>
        </div>
      </div>
    </BWAccordion>
  );
};

export default RecruitmentInformation;
